export enum BuildQuotesStates {
  IS_ESTIMATE = "isEstimate",
  IS_QUOTE = "isQuote",
  IS_READ_ONLY = "isRead",
}
